<template>
  <SpartenWrapper
    image="images/bedarfsinfo/berufshaftpflicht/header"
    text="Fügen Sie bei der Ausübung ihres Berufes
          einem Dritten einen Schaden zu, so sind Sie
          verpflichtet, diesen zu ersetzen - unabhängig
          von der Schadenhöhe. Eine Berufshaftpflicht
          nimmt Ihnen das finanzielle Risiko ab."
    :versorgungen="data.bedarfsinfo.versorgungen"
    :dokumente="data.bedarfsinfo.dokumente"
    :links="data.bedarfsinfo.links"
    versorgungen-headline="Wie sind wir aktuell bei einem Berufshaftpflichtschaden geschützt?"
    versorgungen-description="Berufshaftpflicht"
  >
    <section class="section">
      <div class="container">
        <div class="flex flex-wrap -mx-4">
          <div class="w-full lg:w-5/6 lg:ml-[8.333333%] px-4">
            <div class="text-center pb-7">
              <h2>Wann leistet die Berufshaftpflicht?</h2>
            </div>

            <div class="text-center pb-7">
              <p>
                Die Berufshaftpflicht trägt die finanziellen Kosten durch Schäden, die Sie einem
                Dritten bei Ausübung Ihres Berufs unbeabsichtigt zugefügt haben.
              </p>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap -mx-4 mt-7">
          <div class="w-full lg:w-5/6 xl:w-2/3 lg:ml-[8.333333%] xl:ml-[16.666667%] px-4">
            <div class="text-center pb-7">
              <h3>Schadenbeispiele - welche Kosten werden erstattet?</h3>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap -mx-4 items-center">
          <div class="w-full md:w-1/2 lg:w-1/3 px-4">
            <SvgVue
              icon="bedarfsinfo/berufshaftpflicht/sachschaden.svg"
              class="block mx-auto my-5"
            />
          </div>

          <div class="w-full md:w-1/2 lg:w-2/3 px-4">
            <div>
              <BulletPoint
                :item="{
                  'title': 'Sachschaden',
                  'text': 'Ein Mitarbeitender entleert den Aschenbecher kurz vor Verlassen der Praxis. ' +
                    'Die Glut entzündet ein Feuer, das sich in der Praxis ausbreitet und die angrenzenden ' +
                    'Büros stark beschädigt.'
                }"
              />
            </div>
          </div>
        </div>

        <div class="flex flex-wrap -mx-4 items-center flex-row-reverse">
          <div class="w-full md:w-1/2 lg:w-1/3 px-4">
            <SvgVue
              icon="bedarfsinfo/berufshaftpflicht/personenschaden.svg"
              class="block mx-auto my-5"
            />
          </div>

          <div class="w-full md:w-1/2 lg:w-2/3 px-4">
            <div>
              <BulletPoint
                :item="{
                  'title': 'Personenschaden',
                  'text': 'Im Büro stolpert ein Kunde über ein offen verlegtes Verlängerungskabel und bricht ' +
                    'sich dabei ein Bein. Die Berufshaftpflicht übernimmt die Behandlungs- und Folgekosten und…'
                }"
              />
            </div>
          </div>
        </div>

        <div class="flex flex-wrap -mx-4 items-center">
          <div class="w-full md:w-1/2 lg:w-1/3 px-4">
            <SvgVue
              icon="bedarfsinfo/berufshaftpflicht/unechter-vermoegensschaden.svg"
              class="block mx-auto my-5"
            />
          </div>

          <div class="w-full md:w-1/2 lg:w-2/3 px-4">
            <div>
              <BulletPoint
                :item="{
                  'title': 'Unechter Vermögensschaden',
                  'text': '… darüber hinaus das Schmerzensgeld sowie die Kosten für ' +
                    'den Verdienstausfall der verletzten Person.'
                }"
              />
            </div>
          </div>
        </div>

        <div class="flex flex-wrap -mx-4 justify-center mt-14 mb-0">
          <div class="w-full md:w-5/6 lg:w-1/2 px-4">
            <NiceToKnow
              classes="mb-0"
              :bullets="[{
                title: 'Info',
                text: 'Zusätzlich weist die Versicherung unberechtigte Forderungen ab und setzt dieses ' +
                  'gerichtlich durch (sogenannter passiver Rechtsschutz).'
              }]"
            />
          </div>
        </div>

        <div class="flex flex-wrap -mx-4 mt-5">
          <div class="w-full lg:w-5/6 lg:ml-[8.333333%] px-4">
            <div class="text-center pb-7">
              <h3>Welche zusätzlichen Leistungen bieten Top-Tarife?</h3>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap -mx-4 justify-center">
          <div class="w-full lg:w-5/6 px-4">
            <div class="flex flex-wrap -mx-4">
              <div class="w-full md:w-1/2 px-4">
                <BulletPointList
                  :items="[
                    {
                      text: 'Rückwärtsdeckung (in der Vergangenheit entstandene Schäden, die zum Zeitpunkt ' +
                        'der Antragstellung unbekannt sind).'
                    },
                    { text: 'Haftung gemäß dem allgemeinen Gleichbehandlungsgesetz (AGG).' },
                    { text: 'Vertrauensschäden durch Mitarbeiter.' },
                  ]"
                />
              </div>
              <div class="w-full md:w-1/2 px-4">
                <BulletPointList
                  :items="[
                    { text: 'Verlust schriftlicher Arbeitsdokumente.' },
                    { text: 'Domainschutzversicherung.' },
                  ]"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap -mx-4 mt-14">
          <div class="w-full lg:w-5/6 lg:ml-[8.333333%] px-4">
            <div class="text-center pb-7">
              <h3>Wann habe ich keinen Versicherungsschutz?</h3>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap -mx-4 justify-center">
          <div class="w-full lg:w-5/6 px-4">
            <div class="flex flex-wrap -mx-4">
              <div class="w-full md:w-1/2 px-4">
                <BulletPointList
                  :items="[
                    { text: 'Bei echten Vermögensschäden (tarifabhängig).' },
                    { text: 'Bei Eigenschäden, die Sie sich selbst oder einer mitversicherten Person zufügen.' },
                    { text: 'Bei vorsätzlich herbeigeführten Schäden.' },
                  ]"
                />
              </div>
              <div class="w-full md:w-1/2 px-4">
                <BulletPointList
                  :items="[
                    { text: 'Bei Schäden an gemieteten oder geliehenen Gegenständen.'},
                    {
                      text: 'Bei Schäden infolge von Veruntreuung oder wissentliches Abweichen von ' +
                        'Vorschriften oder Gesetzen.',
                    },
                  ]"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap -mx-4 mt-5">
          <div class="w-full md:w-1/2 px-4">
            <NiceToKnow
              classes=""
              :bullets="[{
                title: 'Info:',
                text: 'Ein sogenannter echter Vermögensschaden entsteht, wenn der Vermögensschaden ohne ' +
                  'zusätzlichen Personen- oder Sachschaden entstanden ist. Dieses kann über eine separate ' +
                  'Vermögensschadenhaftpflicht versichert werden und ist für alle beratenden Berufe sehr wichtig.'
              }]"
            />
          </div>
          <div class="w-full md:w-1/2 px-4">
            <NiceToKnow
              classes=""
              :bullets="[{
                title: 'Info:',
                text: 'Diese Aufzählung beinhaltet wesentliche Leistungsausschlüsse und ist nicht abschließend. ' +
                  'Sofern einzelne Leistungspunkte für Sie wichtig sind, prüfen wir gerne Sondertarife.'
              }]"
            />
          </div>
        </div>
      </div>
    </section>
  </SpartenWrapper>
</template>

<script setup lang="ts">
import SvgVue from '@/application/components/SvgVue';
import BulletPoint from '@/bedarf/components/BulletPoint.vue';
import BulletPointList from '@/bedarf/components/BulletPointList.vue';
import NiceToKnow from '@/bedarf/components/NiceToKnow.vue';
import SpartenWrapper from '@/bedarf/components/SpartenWrapper.vue';
import type { UnfallInfo } from '@/bedarf/types/bedarfsinfo';

interface Props {
  data: UnfallInfo,
}

defineProps<Props>();
</script>
